import { bursariesApi } from "../api/hliLists";
import GrantedStudentsPage from "./granted/GrantedStudentsPage";

// Students of the signed-in HLI admin's institution who were granted a bursary
export default function HliGrantedStudents() {
  return <GrantedStudentsPage list={bursariesApi.myGranted} scope="mine" subtitle="Students from your institution who were granted a bursary" />;
}
